import { render, staticRenderFns } from "./SalesItem.vue?vue&type=template&id=1f3fa656&scoped=true&"
import script from "./SalesItem.vue?vue&type=script&lang=js&"
export * from "./SalesItem.vue?vue&type=script&lang=js&"
import style0 from "./SalesItem.vue?vue&type=style&index=0&id=1f3fa656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3fa656",
  null
  
)

export default component.exports